<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-card>
		<v-card-title>
			<h2>Waluty</h2>
			<v-spacer></v-spacer>
		</v-card-title>
		<br/>
		<v-dialog v-model="dialog" max-width="800px">
			<v-btn slot="activator" color="primary" dark class="mb-2">Dodaj walutę</v-btn>
			<v-card>
				<v-card-title>
					<span class="headline" v-if="isEdited"> Edycja waluty </span>
					<span class="headline" v-else> Dodaj nową walutę </span>
				</v-card-title>

				<v-card-text>
					<v-container grid-list-md>
						<v-form ref="form"
							v-model="valid"
							lazy-validation>

							<v-layout wrap>
								<v-flex xs4 sm2 md4>
									<v-text-field
										browser-autocomplete="off"
										v-model="editedItem.name"
										label="Nazwa"
										aria-label="name"
										for="currencies-view-name"
										id="currencies-view-name"
										:rules="validation.nameRules" name="name"></v-text-field>
								</v-flex>
								<v-flex xs4 sm2 md4>
									<v-text-field
										browser-autocomplete="off"
										v-model="editedItem.code"
										label="Kod"
										aria-label="code"
										for="currencies-view-code"
										id="currencies-view-code"
										:rules="validation.codeRules" name="code"></v-text-field>
								</v-flex>
								<v-flex xs4 sm2 md4>
									<egranty-number-input-field
										name="exchangeRate"
										aria-label="exchange rate"
										v-model="editedItem.exchangeRate"
										label="Wartość w PLN"
										for="currencies-view-valuePLN"
										id="currencies-view-valuePLN"
										:rules="validation.exchangeRateRules"
										suffix=" PLN"
										:fractional-len="5"
									></egranty-number-input-field>
									<!--									<v-text-field-->
									<!--										browser-autocomplete="off"-->
									<!--										v-model="editedItem.exchangeRate"-->
									<!--										label="Wartość w PLN"-->
									<!--										for="currencies-view-valuePLN"-->
									<!--										id="currencies-view-valuePLN"-->
									<!--										:rules="validation.exchangeRateRules" name="exchangeRate"></v-text-field>-->
								</v-flex>
							</v-layout>
							<v-layout wrap>
								<v-flex xs4 sm2 md4>
									<v-menu
										v-model="exchangeDateMenu"
										:close-on-content-click="false"
										:nudge-right="40"
										lazy
										transition="scale-transition"
										offset-y
										full-width
										min-width="290px"
									>
										<template v-slot:activator="{ on }">
											<v-text-field
												v-model="editedItem.exchangeDate"
												label="Data kursu"
												prepend-icon="event"
												browser-autocomplete="off"
												aria-label="exchange date"
												for="exchange-date"
												id="exchange-date"
												readonly
												v-on="on"
											></v-text-field>
										</template>
										<v-date-picker no-title :first-day-of-week="1" scrollable locale="pl-PL"
											v-model="editedItem.exchangeDate" @input="exchangeDateMenu = false"/>
									</v-menu>
								</v-flex>
							</v-layout>

							<div v-if="showWrongDataMessage" style="color:red;">
								Niepoprawne dane.
							</div>
						</v-form>
					</v-container>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue" @click="close">Anuluj</v-btn>
					<v-btn color="primary" flat @click="save">Zapisz</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-data-table
			hide-actions
			:headers="headers"
			:items="items"
			class="elevation-1"
		>
			<template slot="items" slot-scope="props">
				<td class="text-xs-left">{{ props.item.name }}</td>
				<td class="text-xs-left">{{ props.item.code }}</td>
				<td class="text-xs-left">{{ props.item.exchangeDate }}</td>
				<td class="text-xs-left">{{ formatWithoutFixed(props.item.exchangeRate) }}</td>
				<td class="text-xs-left">
					<v-tooltip bottom>
						<template v-slot:activator="{ on }" >
							<v-btn icon
								@click="editItem(props.item)" >
								<v-icon v-on="on">
									edit
								</v-icon>
							</v-btn>
						</template>
						<span>Edytuj</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on }" >
							<v-btn icon
								@click="deleteItem(props.item)" >
								<v-icon v-on="on" color="lightred">
									delete
								</v-icon>
							</v-btn>
						</template>
						<span>Usuń</span>
					</v-tooltip>
				</td>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>
	import {Currency} from "../../../api/generated/Currency";
	import {Numbers} from "../../../utils/Numbers";
	import egrantyNumberInputField from "../../../genericComponents/EgrantyNumberInputField";


	export default {
		name: "CurrenciesView",
		components: {
			egrantyNumberInputField,
		},

		mixins: [Numbers],

		watch: {
			dialog(val) {
				!val && this.close();
			},
		},

		computed: {
			isEdited() {
				return this.editedIndex !== -1;
			},
		},

		data() {
			return {
				headers: [
					{text: "Nazwa waluty", value: "name", sortable: false},
					{text: "Kod waluty", value: "code", sortable: false},
					{text: "Data kursu", value: "exchangeDate", sortable: false},
					{text: "Wartość w PLN", value: "exchangeRate", sortable: false},
					{text: "Akcje", value: "actions", sortable: false},
				],

				valid: true,

				validation: {
					nameRules: [
						v => !!v || "Nazwa jest wymagana",
					],
					codeRules: [
						v => !!v || "Kod waluty jest wymagany",
					],
					exchangeRateRules: [
						v => !!v || "Podanie wartości w PLN jest obowiązkowe",
					],
				},

				errorMessage: null,

				showWrongDataMessage: false,

				dialog: false,

				items: [],

				editedItem: {},

				editedIndex: -1,
				exchangeDateMenu: false
			};
		},

		methods: {
			editItem(item) {
				this.editedIndex = this.items.indexOf(item);
				this.editedItem = Object.assign({}, item);
				this.dialog = true;
			},

			deleteItem(item) {
				this.$confirm("Czy na pewno chcesz usunąć walutę?", {
					icon: 'delete',
					title: 'Usuwanie waluty',
					color: 'lightred',
					width: 500
				})
					.then(response => {
						if (response) {
							Currency.delete(this, item.id, successResponse => {
									this.refresh();
									this.$messagesBus.$emit("success", "Waluta została pomyślnie usunięta", successResponse);
								},
								errorResponse => {
									this.$messagesBus.$emit("error", "Nie udało się usunąć waluty", errorResponse);
								});
						}
					});
			},

			close() {
				this.dialog = false;
				this.editedIndex = -1;
				this.editedItem = {};
				this.$refs.form.reset();
				this.$refs.form.resetValidation();
				this.errorMessage = "";
				this.showWrongDataMessage = false;
			},

			save() {
				if (this.editedIndex === -1) {
					this.create();
				} else {
					this.update();
				}
			},

			create() {
				Currency.post(this, {
						name: this.editedItem.name,
						code: this.editedItem.code,
						exchangeDate: this.editedItem.exchangeDate,
						exchangeRate: this.editedItem.exchangeRate,
					},
					successResponse => {
						this.editedItem.id = successResponse;
						this.items.push(this.editedItem);
						this.refresh();
						this.close();
						this.$messagesBus.$emit("success", "Waluta została pomyślnie dodana", successResponse);
					},
					errorResponse => {
						this.showWrongDataMessage = true;
						this.$messagesBus.$emit("error", "Nie udało się dodać waluty", errorResponse);
					});
			},

			update() {
				Currency.put(this, {
						id: this.editedItem.id, name: this.editedItem.name,
						exchangeDate: this.editedItem.exchangeDate,
						code: this.editedItem.code, exchangeRate: this.editedItem.exchangeRate,
					},
					successResponse => {
						Object.assign(this.items[this.editedIndex], this.editedItem);
						this.refresh();
						this.close();
						this.$messagesBus.$emit("success", "Waluta została pomyślnie zapisana", successResponse);
					},
					errorResponse => {
						this.showWrongDataMessage = true;
						this.$messagesBus.$emit("error", "Nie udało się zapisać waluty", errorResponse);
					});
			},

			refresh() {
				Currency.get(this, successResponse => {
						this.items = successResponse;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się pobrać listy walut", errorResponse);
					});
			},
		},

		mounted() {
			this.refresh();
		},
	};
</script>

<style scoped>

</style>
